/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} What_Were_The_HighlightsInputs */

const en_what_were_the_highlights = /** @type {(inputs: What_Were_The_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What Were the Highlights?`)
};

const es_what_were_the_highlights = /** @type {(inputs: What_Were_The_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuáles fueron los mejores momentos?`)
};

const fr_what_were_the_highlights = /** @type {(inputs: What_Were_The_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels ont été les moments forts ?`)
};

const de_what_were_the_highlights = /** @type {(inputs: What_Were_The_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was waren die Höhepunkte?`)
};

const ja_what_were_the_highlights = /** @type {(inputs: What_Were_The_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハイライトは何でしたか？`)
};

const zh_what_were_the_highlights = /** @type {(inputs: What_Were_The_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有哪些亮点？`)
};

const ar_what_were_the_highlights = /** @type {(inputs: What_Were_The_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما هي أبرز اللحظات؟`)
};

const id_what_were_the_highlights = /** @type {(inputs: What_Were_The_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa Saja Sorotan Utamanya?`)
};

const it_what_were_the_highlights = /** @type {(inputs: What_Were_The_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quali sono stati i momenti salienti?`)
};

const ru_what_were_the_highlights = /** @type {(inputs: What_Were_The_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Какие были самые яркие моменты?`)
};

const pt_what_were_the_highlights = /** @type {(inputs: What_Were_The_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais foram os melhores momentos?`)
};

const ko_what_were_the_highlights = /** @type {(inputs: What_Were_The_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`하이라이트는 무엇이었나요?`)
};

/**
* | output |
* | --- |
* | "What Were the Highlights?" |
*
* @param {What_Were_The_HighlightsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const what_were_the_highlights = /** @type {((inputs?: What_Were_The_HighlightsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<What_Were_The_HighlightsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_what_were_the_highlights(inputs)
	if (locale === "es") return es_what_were_the_highlights(inputs)
	if (locale === "fr") return fr_what_were_the_highlights(inputs)
	if (locale === "de") return de_what_were_the_highlights(inputs)
	if (locale === "ja") return ja_what_were_the_highlights(inputs)
	if (locale === "zh") return zh_what_were_the_highlights(inputs)
	if (locale === "ar") return ar_what_were_the_highlights(inputs)
	if (locale === "id") return id_what_were_the_highlights(inputs)
	if (locale === "it") return it_what_were_the_highlights(inputs)
	if (locale === "ru") return ru_what_were_the_highlights(inputs)
	if (locale === "pt") return pt_what_were_the_highlights(inputs)
	return ko_what_were_the_highlights(inputs)
});